<template>

    <div>
      <div class="g-form relative">
        <input
          class="bg-transparent text-gray-700 w-full border-none py-1 hover:bg-gray-100 focus:bg-gray-100 focus:ring-transparent dark:hover:bg-gray-700 dark:focus:bg-gray-700 dark:text-gray-400"
          placeholder="Add Guest Email"
          type="text"
          v-model="searchQuery"
          @input="searchContacts"
        />
        <div class="before-absolute bg-blue-600 transform scale-x-0 transform-origin-center w-full h-[2px] left-0 rounded-[30px] bottom-0 transition-transform duration-300 ease-in-out"></div>
        <span>
            <div v-if="showDropdown" @click="toggleDropdown" class="click fixed inset-0"></div>
            <div v-if="showDropdown && searchQuery != ''" class="absolute z-10 mt-2 bg-white border rounded max-h-40 overflow-y-auto scrollbar-style dark:bg-[#1C2128] dark:text-gray-400">
              <button v-for="contact in contacts" class="hover:bg-gray-50 text-sm dark:hover:bg-gray-600 w-full flex items-center text-left py-2 px-4" 
                      :key="contact.id"
                      :class="{ 'bg-gray-100 pointer-events-none text-gray-400': contact.isAttendee, 'regular-style': !contact.isAttendee }"
                      @click="selectContact(contact)">
                <div class="flex items-end w-8">
                  <p :class="{ 'bg-gray-300': contact.isAttendee, 'bg-gray-500': !contact.isAttendee }" class="w-6 h-6 flex justify-center items-center rounded-full text-white text-sm">{{ contact.email.charAt(0).toUpperCase() }}</p>
                </div>
                {{ contact.email }}
                <span v-if="contact.isAttendee" class="ml-auto">
                    <span class="ml-5 w-6 h-6 flex items-center justify-center rounded-full bg-white/80">
                        <svg class="w-4 h-4 fill-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>
                    </span>
                </span>
              </button>
            </div>
        </span>
      </div>
      <div v-if="attendees.length > 0" class="flex mt-2">
          <div class="flex-col flex-grow">
            <div class="text-gray-700 text-sm">
              <div v-for="(attendee, index) in attendees" :key="index" class="flex hover:bg-gray-50 items-center py-1 group dark:hover:bg-gray-700 dark:text-gray-400">
                <div class="flex items-end w-8">
                  <p class="w-6 h-6 flex justify-center bg-gray-500 items-center rounded-full text-white text-sm">{{ attendee.email.charAt(0).toUpperCase() }}</p>
                </div>
                <p class="ml-2">{{ attendee.email }}</p>
                <button data-tooltip-target="tooltip-remove" data-tooltip-placement="top" class="ml-auto hidden w-6 h-6 rounded-full hover:bg-gray-100 justify-center items-center dark:hover:bg-gray-600 group-hover:inline-flex focus:inline-flex" @click="removeAttendee(index)" title="Remove attendee">
                    <svg class="w-5 h-5 fill-gray-500 dark:fill-gray-400" xmlns='http://www.w3.org/2000/svg'  viewBox='0 0 24 24'><path d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"></path></svg>
                </button>
                <div id="tooltip-remove" role="tooltip" class="absolute z-10 invisible inline-block px-2 py-1 text-xs font-medium text-white transition-opacity duration-300 bg-gray-700 rounded shadow-sm opacity-0 tooltip ">
                      Remove
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  
</template>

<script>
import Constants from "controllers/vue_components/mixins/constants";
import RequestMixin from "controllers/vue_components/mixins/request"

export default {
    name: 'SearchContactsDropdown',
    mixins: [Constants, RequestMixin],
    props: [],
    data() {
        return {
            searchQuery: '',
            contacts: [],
            attendees: [],
            showDropdown: false
        };
    },
    methods: {
        async searchContacts() {
            if (this.isValidEmail(this.searchQuery)) {
                // Add searchQuery to contacts if it is a valid email
                this.contacts = [{ email: this.searchQuery, isAttendee: this.isAttendee(this.searchQuery) }];
                this.showDropdown = true;
            } else {
                let response = await this.axiosRequest('POST', `/api/v1/host/contacts/search`, { search: { query: this.searchQuery } }, false);
                this.contacts = response.response.data.map(contact => ({
                    ...contact,
                    isAttendee: this.isAttendee(contact.email)
                }));
                this.showDropdown = true;
            }
        },

        isAttendee(email) {
            return this.attendees.some(attendee => attendee.email === email);
        },

        isValidEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },
        removeAttendee(index) {
            this.attendees.splice(index, 1);
            this.$emit('change', this.attendees );
        },
        selectContact(contact) {
            if (!this.attendees.some(a => a.email === contact.email)) {
                this.attendees.push({ email: contact.email });
            }
            this.$emit('change', this.attendees );
            this.searchQuery = '';
            this.showDropdown = false;
        },
        toggleDropdown(){
            this.showDropdown = !this.showDropdown;
        }
    },

    computed: {


    }
};
</script>
